module.exports = __webpack_public_path__ + "static/img/0625.bd8d339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/0625.png
// module id = 9NMR
// module chunks = 3